import * as React from 'react';
import styles from '../../css/MobileCloseButton.module.css';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

export default function MobileCloseButton(props) {
  const { i18n } = useTranslation();

  MobileCloseButton.propTypes = {
    onClose: PropTypes.func
  };

  return (
    <button type="button" className={cx('btn-close')} onClick={props.onClose} lang={i18n.language}>
      Close
    </button>
  );
}